const DEFAULT_HTTP_BASE_URL = 'http://192.168.0.45:3001';

function trimTrailingSlash(value) {
  return String(value || '').trim().replace(/\/+$/, '');
}

function getHttpBaseUrl(env = process.env) {
  const configured = trimTrailingSlash(env && env.REACT_APP_KELIMO_SERVER_URL);
  if (env && env.NODE_ENV === 'production' && configured && !configured.startsWith('https://')) {
    throw new Error('Production Kelimo endpoint must use HTTPS');
  }
  if (env && env.NODE_ENV === 'production' && !configured) {
    if (typeof window !== 'undefined' && /^https:\/\//.test(window.location.origin)) return window.location.origin;
    throw new Error('Production requires an HTTPS REACT_APP_KELIMO_SERVER_URL');
  }
  return configured || DEFAULT_HTTP_BASE_URL;
}

function getWebSocketUrl(env = process.env) {
  const baseUrl = getHttpBaseUrl(env);

  if (baseUrl.startsWith('https://')) {
    return `wss://${baseUrl.slice('https://'.length)}`;
  }

  if (baseUrl.startsWith('http://')) {
    return `ws://${baseUrl.slice('http://'.length)}`;
  }

  if (baseUrl.startsWith('wss://') || baseUrl.startsWith('ws://')) {
    return baseUrl;
  }

  throw new Error(`Unsupported Kelimo server URL: ${baseUrl}`);
}

function getApiUrl(pathname, env = process.env) {
  const path = String(pathname || '');
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  // CRA proxies HTTP API requests from the PC development origin. The WebSocket
  // may still use the configured LAN host so an iPhone can join the same game.
  if (!env.REACT_APP_KELIMO_SERVER_URL && env.NODE_ENV !== 'production' &&
      typeof window !== 'undefined' && window.location.hostname === 'localhost' &&
      window.location.port === '3000') return `${window.location.origin}${normalizedPath}`;
  return `${getHttpBaseUrl(env)}${normalizedPath}`;
}

function resolveAvatarUrl(value, env = process.env) {
  if (typeof value !== 'string' || !value) return value;
  if (value === '/default-avatar.png') return getApiUrl(value, env);
  if (value.startsWith('/uploads/avatars/')) return getApiUrl(value, env);
  try {
    const url = new URL(value);
    // Legacy generated avatars sent player identifiers to third-party hosts.
    if (['ui-avatars.com', 'i.pravatar.cc'].includes(url.hostname)) return getApiUrl('/default-avatar.png', env);
    // Older users.json records can contain an absolute development LAN host.
    if (url.pathname.startsWith('/uploads/avatars/') &&
        (url.hostname === 'localhost' || /^\d{1,3}(?:\.\d{1,3}){3}$/.test(url.hostname))) {
      return getApiUrl(`${url.pathname}${url.search}`, env);
    }
  } catch (_) { /* External avatar URLs are kept as they were. */ }
  return value;
}

module.exports = {
  DEFAULT_HTTP_BASE_URL,
  getHttpBaseUrl,
  getWebSocketUrl,
  getApiUrl,
  resolveAvatarUrl
};
